import { createSelector } from 'reselect';
import { Map, List, get } from 'immutable';

const selectFundingSearch = (state) => state.get('fundingSearch');
const selectFundingSearchIdFromProps = (_, props) => get(props, 'fundingSearchId', '');

const makeSelectSearchFollowers = () =>
  createSelector(selectFundingSearch, (state) => state.get('fundingSearchFollowers', Map()));

const makeSelectSearchFollowersLoading = () =>
  createSelector(
    makeSelectSearchFollowers(),
    selectFundingSearchIdFromProps,
    (state, fundingSearchId) => state.getIn([fundingSearchId, 'network', 'loading'], false),
  );

const makeSelectSearchFollowersList = () =>
  createSelector(
    makeSelectSearchFollowers(),
    selectFundingSearchIdFromProps,
    (state, fundingSearchId) => state.getIn([fundingSearchId, 'data'], List()),
  );

const makeSelectSearchFollowersListSorted = () =>
  createSelector(makeSelectSearchFollowersList(), (list) =>
    list.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())),
  );

export {
  makeSelectSearchFollowersLoading,
  makeSelectSearchFollowersList,
  makeSelectSearchFollowersListSorted,
};
